module.exports = __webpack_public_path__ + "static/img/PCBA_img_2.60e793b.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/nav/img/PCBA_img_2.png
// module id = wB6h
// module chunks = 22